import { render, staticRenderFns } from "./NileUgBase.vue?vue&type=template&id=dce93b1e&"
import script from "./NileUgBase.vue?vue&type=script&lang=js&"
export * from "./NileUgBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports